import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useTheme } from "../context/ThemeContext";
import { toast } from "sonner";

export default function ComingSoon({ title, subtitle, source = "general" }) {
  const t = useTheme();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/subscribe", { email, source });
      setSubmitted(true);
      toast.success("You're on the list. We'll be in touch soon.");
    } catch {
      toast.error("Couldn't submit — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-20" data-testid={`coming-soon-${source}`}>
      <div className="max-w-xl w-full text-center">
        <div className="text-[11px] tracking-[0.4em] uppercase" style={{ color: t.primary }}>Coming Soon</div>
        <h1 className="mt-5 text-4xl sm:text-5xl leading-tight" style={{ color: t.text }}>{title}</h1>
        {subtitle && <p className="mt-5 opacity-80 leading-relaxed">{subtitle}</p>}

        {submitted ? (
          <div className="mt-10 p-6 bg-white border border-[#E5E5E5]" style={{ borderBottom: `3px solid ${t.primary}` }} data-testid="coming-soon-success">
            <div className="text-xs uppercase tracking-[0.3em]" style={{ color: t.primary }}>Thank you</div>
            <p className="mt-3 text-sm opacity-85">We've added <span className="font-medium">{email}</span> to the list. You'll be among the first to know.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-3" data-testid="coming-soon-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 p-4 border border-[#E5E5E5] bg-white outline-none focus:border-[#CC2222]"
              data-testid="coming-soon-email"
            />
            <button
              type="submit"
              disabled={busy}
              className={`px-8 py-4 text-xs tracking-[0.3em] uppercase ${t.btnPrimary} disabled:opacity-50`}
              data-testid="coming-soon-submit"
            >
              {busy ? "Sending…" : "Notify Me"}
            </button>
          </form>
        )}

        <Link to="/" className="mt-12 inline-block text-xs tracking-[0.2em] uppercase opacity-60 hover:opacity-100">← Back to Home</Link>
      </div>
    </div>
  );
}
